import React from "react";
import PropTypes from "prop-types";
import { Typography, CircularProgress, Box, Fab, IconButton, Alert, Stack } from "@mui/material";
import { indigo } from "@mui/material/colors";
import { FaChevronDown, FaRegLightbulb } from "react-icons/fa";
import { MdNorthEast } from "react-icons/md";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

import CprStatusItem from "../cpr/CprStatusItem";
import * as CONST from "../../Constants";

const propTypes = {
  cprs: PropTypes.array.isRequired,
  in_progress: PropTypes.object.isRequired,
  window: () => Window,
  notifications: PropTypes.array.isRequired,
  window: PropTypes.func,
  children: PropTypes.object.isRequired,
};
CprsList.prototype = propTypes;

export default function CprsList(props) {
  React.useEffect(() => {}, [props.notifications, props.messages, props.cprs]);
  return (
    <>
      <Box pt={2} pb={1}>
        <Typography variant="h4" fontWeight="600" color={indigo[900]} sx={{ m: 1 }}>
          {CONST.DASHBOARD.TITLE}
        </Typography>
      </Box>
      <Stack justifyContent="center" spacing={2}>
        {props.in_progresscount == 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ m: 1 }}>
            {CONST.DASHBOARD.NO_CPRS}
          </Typography>
        )}
        {!!props.notifications.length > 0 && (
          <>
            <Alert severity="info" className="tip" icon={<FaRegLightbulb />} sx={{ mb: 1 }}>
              <Typography variant="body2">
                <b>FYI: </b>
                {props.notifications.length} {CONST.DASHBOARD.NOTIFICATIONS_1}
                {CONST.DASHBOARD.CLICK}
                <IconButton className="card-button">
                  <MdNorthEast />
                </IconButton>
                {CONST.DASHBOARD.NOTIFICATIONS_2}
              </Typography>
            </Alert>

            {props.notifications.map((cpr) => {
              return (
                <CprStatusItem
                  {...props}
                  key={cpr.id}
                  cpr={cpr}
                  dispatch={props.dispatch}
                  handleUpdate={(cpr) => console.log("cprUpdated[Dashboard]", cpr)}
                  flash={(msg) => console.log(msg)}
                />
              );
            })}
          </>
        )}
        {!!props.cprs.length > 0 && (
          <>
            <Alert severity="info" className="tip" icon={<FaRegLightbulb />} sx={{ mb: 1 }}>
              <Typography variant="body2">
                {CONST.DASHBOARD.CLICK}
                <IconButton className="card-button more-actions-button">More Actions</IconButton>
                {CONST.DASHBOARD.CPR}
              </Typography>
            </Alert>

            {props.cprs.map((cpr) => {
              if (!cpr.needs_response) {
                return (
                  <CprStatusItem
                    {...props}
                    key={cpr.id}
                    cpr={cpr}
                    dispatch={props.dispatch}
                    handleUpdate={(cpr) => console.log("cprUpdated[Dashboard]", cpr)}
                    flash={(msg) => console.log(msg)}
                  />
                );
              }
            })}
          </>
        )}
      </Stack>
      <Box textAlign="center" color={"#506d7d"} className="cprs-list-message">
        {props.fetching.in_progress && <CircularProgress />}
        {!props.fetching.in_progress && !props.in_progress.fetched && (
          <Fab
            className="load-more"
            aria-label="load more care plan requirements"
            onClick={(e) => {
              props.fetch.cprs();
            }}
          >
            <FaChevronDown />
          </Fab>
        )}
        <Box mt={2} pb={2}>
          <Typography variant="messagebody" fontWeight={300} className="icon-text">
            {props.fetching.in_progress ? (
              CONST.LOADING
            ) : !props.in_progress.fetched ? (
              CONST.LOAD_MORE_CPRS
            ) : (
              <>
                <IoMdCheckmarkCircleOutline />
                {CONST.ALL_CPRS_LOADED}
              </>
            )}
          </Typography>
        </Box>
      </Box>
    </>
  );
}
